import React from 'react';
import { AlertCircleIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { CHECKOUT_BASIC, CHECKOUT_PREMIUM } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="border-b border-line bg-canvas" data-id="element-87" data-mp="844al66a2vea">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10 lg:py-12" data-id="element-88" data-mp="m4f1283oe7yx">
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-10" data-id="element-89" data-mp="h5vdy4dciq4z">
          <Reveal data-id="element-90" data-mp="h5c5rfdhzg45">
            <h2 id="cierre" className="text-center font-display text-2xl md:text-4xl font-black uppercase leading-[1.1] text-ink lg:text-left" data-id="element-91" data-mp="h4153ofcmoh9">
              Tu próximo proyecto puede empezar hoy
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-ink-muted" data-id="element-92" data-mp="14whllujfu8eg">
              Podés seguir guardando videos, descargando PDFs y pensando “algún
              día voy a aprender bien Electrónica”. O podés empezar a construir
              una base organizada desde hoy. Porque el conocimiento que nunca
              llevás a la práctica sigue siendo solamente información.
            </p>
            <p className="mt-3 font-display text-lg md:text-xl font-extrabold uppercase leading-snug text-accent" data-id="element-93" data-mp="2m21e6zgf4s3h">
              La Electrónica puede convertirse en mucho más que un hobby.
            </p>
            <p className="mt-2 text-sm text-ink-muted" data-id="element-94" data-mp="2v2zhffj18vl0">
              Una nueva habilidad. Un proyecto. Un servicio. Una herramienta
              profesional. Una forma de enseñar. O el comienzo de tu próximo
              emprendimiento.
            </p>

            <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs font-medium text-ink-muted" data-id="element-95" data-mp="39syd9bn47uxb">
              <span className="flex items-center gap-1.5" data-id="element-96" data-mp="3esb19zpq381h">
                <LockIcon size={14} className="text-ink-subtle" data-id="element-97" data-mp="3eposjwr3imho" />
                Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-98" data-mp="1jo3i5j6gg94k">
                <ZapIcon size={14} className="text-accent" data-id="element-99" data-mp="1jolcubdgyfad" />
                Acceso digital inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-100" data-mp="1enfi68090hy7">
                <ShieldCheckIcon size={14} className="text-success" data-id="element-101" data-mp="1shgjn9il4j29" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-102" data-mp="1nnu4naoy833a">
                <CreditCardIcon size={14} className="text-volt" data-id="element-103" data-mp="22drxw51qjizc" />
                Mercado Pago
              </span>
            </div>
          </Reveal>

          <Reveal delay={0.05} className="rounded-2xl border border-line bg-surface p-5 md:p-6" data-id="element-104" data-mp="1xi47xnffilss">
            <span className="inline-flex items-center gap-2 rounded-lg bg-danger-soft px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-danger" data-id="element-105" data-mp="27dee8ncv1fcd">
              <AlertCircleIcon size={14} data-id="element-106" data-mp="h3kt74m8cnvq" />
              Oferta activa
            </span>

            <div className="mt-4 rounded-xl border border-line bg-surface-alt p-4" data-id="element-107" data-mp="d1prhz0e08hf">
              <p className="font-display text-sm font-extrabold uppercase text-ink" data-id="element-108" data-mp="2whu2yq5au6c">
                Mega Pack Electrónica para Emprender
              </p>
              <p className="mt-0.5 text-xs text-ink-muted" data-id="element-109" data-mp="3pbspn17z04jk">
                6 Tomos + 6 Bonos
              </p>
              <p className="mt-2 flex items-baseline gap-2" data-id="element-110" data-mp="3u9uanroyidxo">
                <span className="text-sm text-ink-subtle line-through" data-id="element-111" data-mp="3u8at7xrkdwub">
                  $51.000
                </span>
                <span className="font-display text-2xl font-black text-ink" data-id="element-112" data-mp="3kc7uz2zu2icn">
                  $19.990 ARS
                </span>
              </p>
              <CtaButton href={CHECKOUT_BASIC} external variant="secondary" className="mt-3" data-id="element-113" data-mp="36e9ftvdouhw3">
                Quiero el Mega Pack
              </CtaButton>
            </div>

            <div className="mt-3 rounded-xl border-2 border-accent bg-accent-soft p-4" data-id="element-114" data-mp="19k4wlgw2uw61">
              <p className="flex items-center gap-1.5 font-display text-sm font-extrabold uppercase text-accent" data-id="element-115" data-mp="35njc2eko99j4">
                <StarIcon size={13} className="fill-accent" data-id="element-116" data-mp="30nygme4pnjb5" />
                Recomendado — Mega Pack + Kit Emprendedor Pro
              </p>
              <p className="mt-0.5 text-xs text-ink-muted" data-id="element-117" data-mp="2vnskaknhx8mq">
                6 Tomos + 6 Bonos + Kit Emprendedor Pro
              </p>
              <p className="mt-2 flex items-baseline gap-2" data-id="element-118" data-mp="2mooz9b4rqj5l">
                <span className="text-sm text-ink-subtle line-through" data-id="element-119" data-mp="2mq9ul2ywq64i">
                  $69.000
                </span>
                <span className="font-display text-3xl font-black text-accent" data-id="element-120" data-mp="2hvvwgssv1kw5">
                  $27.990 ARS
                </span>
              </p>
              <CtaButton href={CHECKOUT_PREMIUM} external size="lg" className="mt-3" data-id="element-121" data-mp="280kgk75pu7mt">
                Quiero el Mega Pack + Kit Pro
              </CtaButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}